import scrollToWithAnimation from 'scrollto-with-animation';
import inView from 'in-view';

const AgenceLinks = {
  init: () => {
    AgenceLinks.menuAgence = document.querySelectorAll('.menu__item--agence');
    AgenceLinks.agenceHash = document.querySelectorAll('.agence__hash');
    AgenceLinks.menuAgence.forEach(link => {
      link.addEventListener('click', (e) => {
        let div = document.getElementById(link.dataset.hash);
        if (div) {
          let top = div.offsetTop;
          let headerHeight = document.querySelector('.header').getBoundingClientRect().height;
          scrollToWithAnimation(document.querySelector('main'), 'scrollTop', top - headerHeight, 600, 'easeInOutQuad');
        }
      })
    })
    document.querySelector('.main').addEventListener('scroll', () => {
      AgenceLinks.scroll();
    })
  }, 
  scroll: () => {
    AgenceLinks.agenceHash.forEach(hash => {
      if (inView.is(hash) && document.querySelector('.main').scrollTop > 100) {
        AgenceLinks.menuAgence.forEach(link => {
          link.classList.remove('menu__item--active');
          link.classList.remove('menu__item--inactive');
          if (link.dataset.hash == hash.id && link.id != 'linkContact') {
            link.classList.add('menu__item--active');
          } else {
            link.classList.add('menu__item--inactive');
          }
        })
      } else if (document.querySelector('.main').scrollTop <= 100) {
        AgenceLinks.menuAgence.forEach((link, i) => {
          link.classList.remove('menu__item--active');
          link.classList.remove('menu__item--inactive');
          if (i == 0) link.classList.add('menu__item--active');
        })
      }
    })
  }
};

export default AgenceLinks;
